import { FaCheck } from "react-icons/fa";

const Payment = () => {
  return (
    <div className="bg-gray-100 w-full  mt-20 px-20 h-screen flex flex-col items-start ">
      <div className="bg-white w-[70%] h-[50%] px-5 py-5 rounded-lg shadow-md flex flex-col justify-between">
        <div className="top flex flex-col space-y-10">
          <h1 className="text-3xl font-bold">This Month Earning</h1>
          <p className="text-5xl">USD 0</p>
        </div>
        <div className="bottom">
          <h2 className="text-2xl ">Note: Start taking sessions to earn</h2>
        </div>
      </div>
      <div className=" px-5 mt-16 rounded-lg ">
        <ul className="mt-6 space-y-2 text-lg">
          <li className="flex items-start mb-2">
            <FaCheck className="text-green-500 mr-2" />
            You can earn exponentially here at Fynii. It will all depend on the
            quality of your offering and user experience with you.
          </li>
          <li className="flex items-center mb-2">
            <FaCheck className="text-green-500 mr-2" />
            All your earnings will be transferred to your bank account at the
            end of the month.
          </li>
        </ul>
      </div>
    </div>
  );
};
export default Payment;
